import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Component, OnInit, inject } from '@angular/core'

import { scrollTo } from '../helpers/utils'

import { Release, ReleaseService } from './release.service'

@Component({
  standalone: false,
  templateUrl: './releases.component.html',
  styleUrls: ['./releases.component.scss'],
})
export class ReleasesComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver)
  private releaseService = inject(ReleaseService)

  public changelogs: Release[]
  public scrollTo = scrollTo
  public isSmallScreen: boolean

  public ngOnInit(): void {
    this.changelogs = this.releaseService.getAllReleases()
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe((result) => {
        this.isSmallScreen = result.matches
      })
  }

  public parseDate(date: string): string {
    date.replaceAll('.', '/')
    const parsedDate = new Date(date.substring(0, 10))
    return parsedDate.toDateString()
  }
}
